import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import { CustomerProvider } from "@/context/CustomerContext";
import { StoreLayout } from "@/components/StoreLayout";
import HomePage from "@/pages/HomePage";
import ShopPage from "@/pages/ShopPage";
import ProductPage from "@/pages/ProductPage";
import CartPage from "@/pages/CartPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import PaymentCancelPage from "@/pages/PaymentCancelPage";
import TrackOrderPage from "@/pages/TrackOrderPage";
import ReturnsPage from "@/pages/ReturnsPage";
import ReturnLabelSuccessPage from "@/pages/ReturnLabelSuccessPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import TermsOfServicePage from "@/pages/TermsOfServicePage";
import ContactPage from "@/pages/ContactPage";
import CustomerAuthPage from "@/pages/CustomerAuthPage";
import AdminLoginPage from "@/pages/admin/AdminLoginPage";
import AdminLayout from "@/pages/admin/AdminLayout";
import DashboardPage from "@/pages/admin/DashboardPage";
import TrendsPage from "@/pages/admin/TrendsPage";
import PricingPage from "@/pages/admin/PricingPage";
import ProductsAdminPage from "@/pages/admin/ProductsAdminPage";
import OrdersAdminPage from "@/pages/admin/OrdersAdminPage";
import ReturnsAdminPage from "@/pages/admin/ReturnsAdminPage";
import SuppliersPage from "@/pages/admin/SuppliersPage";
import EscalationsPage from "@/pages/admin/EscalationsPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CustomerProvider>
            <CartProvider>
            <Routes>
              <Route element={<StoreLayout />}>
                <Route path="/" element={<HomePage />} />
                <Route path="/shop" element={<ShopPage />} />
                <Route path="/product/:id" element={<ProductPage />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/payment/success" element={<PaymentSuccessPage />} />
                <Route path="/payment/cancel" element={<PaymentCancelPage />} />
                <Route path="/track" element={<TrackOrderPage />} />
                <Route path="/returns" element={<ReturnsPage />} />
                <Route path="/returns/label-success" element={<ReturnLabelSuccessPage />} />
                <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                <Route path="/terms-of-service" element={<TermsOfServicePage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/auth" element={<CustomerAuthPage />} />
              </Route>
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<DashboardPage />} />
                <Route path="trends" element={<TrendsPage />} />
                <Route path="pricing" element={<PricingPage />} />
                <Route path="products" element={<ProductsAdminPage />} />
                <Route path="orders" element={<OrdersAdminPage />} />
                <Route path="returns" element={<ReturnsAdminPage />} />
                <Route path="suppliers" element={<SuppliersPage />} />
                <Route path="escalations" element={<EscalationsPage />} />
              </Route>
            </Routes>
            <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#121216", border: "1px solid rgba(255,255,255,0.1)", color: "#fff" } }} />
            </CartProvider>
          </CustomerProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
